
import React, { useState } from "react";
import { Button } from "@/components/ui/button";
import { AssistantData } from "@/types/assistant";

interface SuggestedQuestionsProps {
  onQuestionClick: (question: string) => void;
  assistantData: AssistantData | null;
}

const SuggestedQuestions: React.FC<SuggestedQuestionsProps> = ({
  onQuestionClick,
  assistantData,
}) => {
  const [isVisible, setIsVisible] = useState(true);

  const greetingText = assistantData?.assistant_data?.greeting || "G'day";
  
  // Define a set of default questions 
  const defaultQuestions = [
    "What restaurants do you recommend nearby?",
    "What time is check-out?",
    "Can you recommend local attractions?",
    "How do I get to the city center?",
  ];

  // Use hotel-specific questions if available, otherwise use defaults
  const questions = defaultQuestions;

  const handleQuestionClick = (question: string) => {
    onQuestionClick(question);
    setIsVisible(false);
  };

  if (!isVisible) return null;

  return (
    <div className="flex flex-col space-y-3 w-full max-w-md mx-auto p-4 animate-fade-in bg-[#F4F1ED]">
      <p className="text-center text-5xl font-family font-medium text-[#162113] mb-4 pb-2 tracking-tight">
        {greetingText}
      </p>
      <div className="flex flex-wrap gap-2 justify-center items-center w-full">
        {questions.map((question, index) => (
          <Button
            key={index}
            variant="outline"
            className="text-center justify-center h-auto py-3 px-4 bg-white hover:bg-midnight-accent/10 border border-[#E7E3DA] text-sm font-normal font-family-serif rounded-full w-auto m-0"
            onClick={() => handleQuestionClick(question)}
            style={{ textAlign: "center", margin: "0 auto" }}
          >
            {question}
          </Button>
        ))}
      </div>
    </div>
  );
};

export default SuggestedQuestions;
